<app-header class="header"></app-header>
<div *ngIf="HTTPActivity && !pageOwnsLoader" class="loader">
  <div>
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
  <div>Loading...</div>
</div>
<div class="layout">
  <router-outlet></router-outlet>
</div>
